<template>
  <div class="text-small pt-3" v-if="response">
    <div><img :src="response.photo_url" class="w-25"></div>
    <div class="pt-3" v-if="response.sub_function_name === 'get_order_code'">
      รูปนี้ คือ รูปรายละเอียดการจอง {{ response.params.order_code }} คุณสามารถดูข้อมูลได้ที่
      <a :href="response.action_url" target="_blank" v-if="response.action_url">
        {{ response.action_url }}
      </a>
    </div>
    <div class="pt-3" v-if="response.sub_function_name === 'get_professional_id'">
      <div v-if="response.action_url">
        รูปนี้ คือ รูปโปรไฟล์คุณแม่บ้าน คุณสามารถดูข้อมูลได้ที่<br>
        <a :href="response.action_url" target="_blank" >
          {{ response.action_url }}
        </a>
      </div>
      <div v-if="response.professionals">
        <div class="pb-2">รูปนี้ คือ รูปโปรไฟล์คุณแม่บ้าน แต่ไม่มีการระบุ id จึงใช้การค้นหาจากชื่อ {{ response.params.name }} แทน ได้ผลลัพธ์ดังนี้</div>
        <div class="d-flex justify-content-start align-items-center pb-2" :key="index" v-for="(professional, index) in response.professionals">
          <div>
            <a :href="`https://admin-test.beneat.co/professional/${professional.id}/profile`" target="_blank">
              <img :src="`https://beneat.s3-ap-southeast-1.amazonaws.com/professionals/${professional.picture}`" class="rounded-circle" width="36">
            </a>
          </div>
          <div class="pl-2">
            <a :href="`https://admin-test.beneat.co/professional/${professional.id}/profile`" target="_blank">
              ID: {{ professional.id }} {{ professional.firstname }} {{ professional.lastname }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-3" v-if="response.sub_function_name === 'get_bank_transfer_slip'">
      รูปนี้ คือ สลิปโอนเงิน ยอด {{ response.params.amount | prettyNumber }} บาท
      <div class="pt-3" v-if="response.user_id">
        <div>หากต้องการใช้สลิปเติมเงินเข้า Wallet สามารถใช้ลิงค์ด้านล่างได้ (โปรดตรวจสอบยอดทุกครั้ง)</div>
        <span>
          <a :href="response.action_url" target="_blank" v-if="response.action_url">
            {{ response.action_url }}
          </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('aiAssistant', ['response'])
  }
}
</script>
